import {
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Component } from '@angular/core';
import {
  DxButtonComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { ParametriPasswords } from '../parametri-passwords';
import { AggiornaPasswordModel } from '../aggiorna-password-model';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-ildato-aggiorna-password',
  templateUrl: './ildato-aggiorna-password.component.html',
  styleUrls: ['./ildato-aggiorna-password.component.scss'],
  imports: [
    DxButtonComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
  ],
})
export class IlDatoAggiornaPasswordComponent {
  @Input() username: string;
  @Input() parametriPasswords: ParametriPasswords;
  @Output() ilDatoAggiornaPasswordEventEmitter =
    new EventEmitter<AggiornaPasswordModel>();

  password: string = '';
  newPassword: string = '';
  newPassword2: string = '';
  errMsg: string;


  onBtnConfermaClick() {
    this.errMsg = null;
    if (!this.password || !this.newPassword || !this.newPassword2) {
      this.errMsg = 'Inserire tutti i campi richiesti';
      return;
    }
    if (this.newPassword != this.newPassword2) {
      this.errMsg = 'Verifica nuova password: le 2 password non coincidono';
      return;
    }
    if (this.newPassword == this.password) {
      this.errMsg = 'La password non può coincidere con la password corrente';
      return;
    }
    if (!this.checkParametriPassword()) {
      this.errMsg = 'La password non soddifa i requisiti richiesti';
      return;
    }
    const newPwdModel = new AggiornaPasswordModel();
    newPwdModel.username = this.username;
    newPwdModel.password = this.password;
    newPwdModel.newPassword = this.newPassword;
    this.ilDatoAggiornaPasswordEventEmitter.emit(newPwdModel);
  }

  checkParametriPassword(): boolean {
    if (
      this.newPassword.length < this.parametriPasswords.lunghezzaMinimaPassword
    ) {
      console.log('Lunghezza minima della password non rispettata');
      return false;
    }
    if (
      this.parametriPasswords.minimoMaiuscolePassword > 0 &&
      this.contaMaiuscole(this.newPassword) <
        this.parametriPasswords.minimoMaiuscolePassword
    ) {
      console.log('Numero minimo di maiuscole non rispettato');
      return false;
    }
    if (
      this.parametriPasswords.minimoMinuscolePassword > 0 &&
      this.contaMinuscole(this.newPassword) <
        this.parametriPasswords.minimoMinuscolePassword
    ) {
      console.log('Numero minimo di minuscole non rispettato');
      return false;
    }
    if (
      this.parametriPasswords.minimoNumeriPassword > 0 &&
      this.contaNumeri(this.newPassword) <
        this.parametriPasswords.minimoNumeriPassword
    ) {
      console.log('Numero minimo di numeri non rispettato');
      return false;
    }
    if (
      this.parametriPasswords.minimoCaratteriSpecialiPassword > 0 &&
      this.contaCaratteriSpeciali(this.newPassword) <
        this.parametriPasswords.minimoCaratteriSpecialiPassword
    ) {
      console.log('Numero minimo di caratteri speciali non rispettato');
      return false;
    }
    return true;
  }

  contaMaiuscole(input: string): number {
    const match = input.match(/[A-Z]/g);
    return match ? match.length : 0;
  }

  contaMinuscole(input: string): number {
    const match = input.match(/[a-z]/g);
    return match ? match.length : 0;
  }

  contaNumeri(input: string): number {
    const match = input.match(/\d/g);
    return match ? match.length : 0;
  }

  contaCaratteriSpeciali(input: string): number {
    const match = input.match(/[^a-zA-Z0-9\s]/g);
    return match ? match.length : 0;
  }
}
